import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Flex, Image } from 'roo-ui/components';
import { luggage } from 'roo-ui/assets';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import Modal from 'components/Modal';
import { useModal } from 'lib/hooks';
import PropertyKnowBeforeYouGo from 'pages/Property/PropertyKnowBeforeYouGo';
import TextButton from 'components/TextButton';
import { useDataLayer } from 'hooks/useDataLayer';

const InfoBox = styled(Box)`
  margin-bottom: ${themeGet('space.10')};
  border: ${themeGet('borders.2')};
  border-color: ${themeGet('colors.greys.alto')};
  padding: ${themeGet('space.6')} 0;
  text-align: center;
  color: ${themeGet('colors.greys.charcoal')};
  border-radius: ${themeGet('radii.default')};
`;

const CheckoutKnowBeforeYouGo = ({ property }) => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Know Before You Go Link', value: 'Link Selected' });
  }, [openModal, emitInteractionEvent]);

  const { checkInInstructions, knowBeforeYouGoDescription, mandatoryFeesDescription } = property;
  return (
    <InfoBox>
      <Flex flexDirection="row" alignItems={['flex-start', 'center']} justifyContent={['flex-start', 'center']} px={2}>
        <Flex justifyContent="center" px={[2, 0]}>
          <Image m={0} width={['64px', '32px']} src={luggage} alt="luggage icon" />
        </Flex>
        <Box ml={[0, 4]} textAlign={['start', 'center']}>
          <Text fontWeight="bold" fontSize={['sm', 'base']}>
            Please note,{' '}
          </Text>
          <Text fontSize={['sm', 'base']}>there is important information about your stay to </Text>
          <TextButton
            fontSize={['sm', 'base']}
            color="greys.charcoal"
            onClick={handleOnClick}
            aria-label="Important information about your stay"
          >
            know before you go.
          </TextButton>
        </Box>
        <Modal {...modalProps} title="Know before you go" data-testid="property-charges">
          <PropertyKnowBeforeYouGo
            checkInInstructions={checkInInstructions}
            knowBeforeYouGoDescription={knowBeforeYouGoDescription}
            mandatoryFeesDescription={mandatoryFeesDescription}
          />
        </Modal>
      </Flex>
    </InfoBox>
  );
};

CheckoutKnowBeforeYouGo.propTypes = {
  property: PropTypes.shape({
    checkInInstructions: PropTypes.string,
    knowBeforeYouGoDescription: PropTypes.string,
    mandatoryFeesDescription: PropTypes.string,
  }),
};

CheckoutKnowBeforeYouGo.defaultProps = {
  property: {},
};

export default CheckoutKnowBeforeYouGo;
